import React from 'react';
import { useIntl } from 'react-intl';
import Tag from '@amzn/meridian/tag';
import { ExceptionStatus } from '@amzn/aet-dynamo-kit';

interface ExceptionStatusTagProps {
  status: ExceptionStatus | null;
}

export const OutlierExceptionStatusTag: React.FC<ExceptionStatusTagProps> = ({
  status,
}) => {
  const intl = useIntl();

  switch (status) {
    case ExceptionStatus.PENDING:
      return (
        <Tag type='neutral'>
          {intl.formatMessage({
            id: 'cs_perfportal_exception_status_tag_pending',
            defaultMessage: 'Pending',
          })}
        </Tag>
      );
    case ExceptionStatus.ACCEPTED:
      return (
        <Tag type='success'>
          {intl.formatMessage({
            id: 'cs_perfportal_exception_status_tag_accepted',
            defaultMessage: 'Accepted',
          })}
        </Tag>
      );
    case ExceptionStatus.DENIED:
      return (
        <Tag type='warning'>
          {intl.formatMessage({
            id: 'cs_perfportal_exception_status_tag_denied',
            defaultMessage: 'Denied',
          })}
        </Tag>
      );
    default:
      // No need to return anything as default since we covered
      // all possible values of enum in the cases above.
      return <></>;
  }
};

export default OutlierExceptionStatusTag;
